export default "__VITE_ASSET__CENNq6y2__"